// Delivery Areas ZIP lookup + list filter
(function () {
    const form = document.querySelector("#cs-zip-check");
    if (!form) return;

    const input = form.querySelector(".cs-zip-input");
    const result = document.querySelector("#cs-zip-result");
    const groups = Array.from(document.querySelectorAll(".cs-zip-group"));

    // Build a set of every served ZIP, and a ZIP -> area-name map
    const zipToArea = new Map();
    groups.forEach((group) => {
        const area = group.dataset.area || "";
        group.querySelectorAll(".cs-zip").forEach((el) => {
            const zip = el.textContent.trim();
            if (!zipToArea.has(zip)) zipToArea.set(zip, area);
        });
    });

    const clearHighlights = () => {
        document.querySelectorAll(".cs-zip.cs-match").forEach((el) => el.classList.remove("cs-match"));
        groups.forEach((g) => (g.hidden = false));
    };

    const showAll = () => {
        clearHighlights();
        result.textContent = "";
        result.className = "";
    };

    const check = (raw) => {
        const zip = (raw || "").trim().slice(0, 5);

        if (zip.length < 5) {
            showAll();
            return;
        }

        clearHighlights();

        if (zipToArea.has(zip)) {
            const area = zipToArea.get(zip);
            result.textContent = area
                ? `Yes — Flower Hero delivers to ${zip} (${area}).`
                : `Yes — Flower Hero delivers to ${zip}.`;
            result.className = "cs-zip-yes";

            // Show only the group(s) containing the match, and highlight it
            groups.forEach((group) => {
                const cells = Array.from(group.querySelectorAll(".cs-zip"));
                const hit = cells.find((el) => el.textContent.trim() === zip);
                if (hit) {
                    hit.classList.add("cs-match");
                    group.hidden = false;
                } else {
                    group.hidden = true;
                }
            });
        } else {
            result.textContent = `We don't show ${zip} in our Harris County list. Call us at the number below — we may still be able to help.`;
            result.className = "cs-zip-no";
            groups.forEach((g) => (g.hidden = false));
        }
    };

    input.addEventListener("input", (e) => check(e.target.value));
    form.addEventListener("submit", (e) => {
        e.preventDefault();
        check(input.value);
    });
})();
